import React, { useState } from 'react';
import SubscribeModal from './SubscribeModal';

const CATEGORIES = [
  { key: 'all', label: 'Home' },
  { key: 'longevity', label: 'Longevity' },
  { key: 'nutrition', label: 'Nutrition' },
  { key: 'research', label: 'Research' },
  { key: 'mental-health', label: 'Mental Health' },
  { key: 'prevention', label: 'Prevention' },
];

/**
 * Shared site header used across all public pages.
 * @param {string} activeSlug - The nav key to highlight as active (e.g. 'longevity', 'all').
 */
function SiteHeader({ activeSlug }) {
  const [showSubscribe, setShowSubscribe] = useState(false);

  return (<>
    <div className="unified-header">
      {/* Top Header Bar */}
      <div className="top-bar">
        <div className="top-bar-content">
          <div className="top-bar-left">
            <span className="date-display">
              {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
            </span>
          </div>
          <div className="top-bar-right">
            <div className="social-icons">
              <a href="#" aria-label="Facebook" onClick={(e) => e.preventDefault()}>
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" aria-label="Twitter" onClick={(e) => e.preventDefault()}>
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="#" aria-label="Instagram" onClick={(e) => e.preventDefault()}>
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
            </div>
            <button className="subscribe-btn" onClick={() => setShowSubscribe(true)}>Subscribe</button>
          </div>
        </div>
      </div>

      {/* Main Header with Logo and Navigation */}
      <header className="news-header">
        <div className="news-header-content">
          <div className="logo-section">
            <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <h1 className="news-logo">DAILY HEALTH</h1>
              <p className="news-tagline">Your Trusted Source for Health &amp; Wellness</p>
            </a>
          </div>
          <nav className="news-nav">
            <div className="news-nav-content">
              {CATEGORIES.map((cat) => (
                <a
                  key={cat.key}
                  href={cat.key === 'all' ? '/' : `/${cat.key}`}
                  className={cat.key === activeSlug ? 'active' : ''}
                >
                  {cat.label}
                </a>
              ))}
            </div>
          </nav>
        </div>
      </header>
    </div>
      <SubscribeModal isOpen={showSubscribe} onClose={() => setShowSubscribe(false)} />
    </>
  );
}

export default SiteHeader;
